import ApiService from '../../components/api_services/apiService.jsx';
import { API_PLAN_TO_UI } from '../promo/promoUtils.js';

const PLAN_SORT_WEIGHT = {
  BASIC: 1,
  STANDARD: 2,
  VISIBILITY_PLUS: 3,
  PREMIUM: 4,
};

const STATUS_PRIORITY = {
  ACTIVE: 2,
  SCHEDULED: 1,
};

const PROMOTIONS_PAGE_SIZE = 500;

export const normalizePromotionSummary = (promo) => ({
  id: promo.id,
  eventId: promo.eventId,
  planType: promo.planType,
  planLabel: promo.planDisplayName || API_PLAN_TO_UI[promo.planType] || promo.planType,
  status: promo.status,
  startsAt: promo.startsAt,
  endsAt: promo.endsAt,
});

const preferPromotion = (current, candidate) => {
  const currentStatusPriority = STATUS_PRIORITY[current.status] || 0;
  const candidateStatusPriority = STATUS_PRIORITY[candidate.status] || 0;
  if (candidateStatusPriority > currentStatusPriority) {
    return candidate;
  }
  if (candidateStatusPriority < currentStatusPriority) {
    return current;
  }

  const currentWeight = PLAN_SORT_WEIGHT[current.planType] || 0;
  const candidateWeight = PLAN_SORT_WEIGHT[candidate.planType] || 0;
  return candidateWeight > currentWeight ? candidate : current;
};

export const buildPromotionByEventId = (promotions) => {
  const result = new Map();

  promotions.forEach((promo) => {
    if (!promo?.eventId) {
      return;
    }

    const summary = normalizePromotionSummary(promo);
    const existing = result.get(promo.eventId);
    result.set(promo.eventId, existing ? preferPromotion(existing, summary) : summary);
  });

  return result;
};

export const fetchActiveAndScheduledPromotions = async () => {
  try {
    const [activeResponse, scheduledResponse] = await Promise.all([
      ApiService.getAdminPromotions(1, PROMOTIONS_PAGE_SIZE, null, null, 'ACTIVE', null, null, null, null),
      ApiService.getAdminPromotions(1, PROMOTIONS_PAGE_SIZE, null, null, 'SCHEDULED', null, null, null, null),
    ]);

    const promotions = [
      ...(activeResponse?.data || []),
      ...(scheduledResponse?.data || []),
    ];

    return buildPromotionByEventId(promotions);
  } catch (error) {
    console.error('Błąd pobierania promocji wydarzeń:', error);
    return new Map();
  }
};

export const getPromotionForEvent = (promotionByEventId, eventId) => {
  if (!promotionByEventId || eventId == null) {
    return null;
  }
  return promotionByEventId.get(Number(eventId)) || promotionByEventId.get(eventId) || null;
};
